import { useState } from "react";
import { productionSummaryRemarkWise } from "../../services/productionService";

export const useProductionRemarkWiseSummary = () => {

    const [summaryToday, setSummaryToday] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


    const fetchTodayProductionSummary = async ({ company, fromDate, toDate }) => {

        const para = { p_from_date: fromDate, p_to_date: toDate };
        // p_companyid: company ?? 13,
        setIsLoading(true)
        try {
            const [todayData] = await Promise.all([
                productionSummaryRemarkWise(para)

            ]);

            setSummaryToday(todayData || []);

            setIsLoading(false);
            return todayData || [];
        } catch (error) {
            alert(error.message);
            setIsLoading(false);
        }
    };






    return {
        summaryToday,
        fetchTodayProductionSummary,
        setSummaryToday,   // optional – if you need reset
        isLoading

    };
};
